import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WFWorker } from 'src/app/store/events.era';
import { publicEditProfileStatusTypes, SocialLink } from '../../store/performers.era';
import { JoiEvent, Label, Ranking } from 'globals/store/events.data';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { environment } from '../../../environments/environment';
import { Exhibitor, exhibitorDisplayTypes, exhibitorTabs, ExhibitorStand } from 'globals/store/exhibitors.data';
import { ManageWrapperComponent, TabGroup } from '../manage/manage-wrapper.component';
import { manageSessionReadonlyReselector } from 'src/app/store/reselectors/sessions.reselector';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { Program } from 'globals/store/programs.data';
import { JoiComment } from 'globals/store/tasks.data';
import { BriefInfo, ItemStatus, PublicEditProfileInfo, ShareableItemTypes, StandItemInfo, StandItemType } from 'globals/store/share.data';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from 'src/app/components/wrapper.component';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { ClipLabel } from 'globals/store/entity.data';
import { exhibitorBriefActionsReselector, exhibitorStandIdsByExhibitorIdReselector } from '../../store/reselectors/exhibitors.reselector';
import { AssetBriefAction, BriefActions } from '../../store/share.brief.functions';
import { associatedAssetsReselector } from '../../store/reselectors/entity.reselector';
import { UpdateQuestionOutput } from '../../components/entities/custom-questions.component';
import { EntityTypesComponent } from 'src/app/components/entities/entity-types.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { CommonModule } from '@angular/common';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { ManageSocialLinksComponent } from '../manage/manage-social.component';
import { ManageCallToActionComponent } from '../manage/manage-call-to-action.component';
import { ManageContactDetailsComponent } from '../manage/manage-contact-details.component';
import { CustomQuestionsAppComponent } from 'src/app/components/entities/custom-questions-app.component';
import { ManageContactComponent } from '../manage/manage-contact.component';
import { ChatBoxComponent } from '../manage/chat-box.component';
import { EntityTasksComponent } from '../manage/entity-tasks.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { InformableComponent } from 'src/app/components/informable/informable.component';
import { AddLinkToBriefComponent } from 'src/app/components/wrappers/add-link-to-brief-wrapper.component';
import { EditAssociatedAssetsManager } from '../assets/edit-associated-assets-manager.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { BigAndGreyComponent } from 'src/app/components/cards/big-and-grey.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { ManageTermsComponent } from '../manage/manage-terms.component';
import { AssetsComponent } from '../assets/assets.component';
import { AppBriefComponent } from '../entities/app-brief.component';
import { ExhibitorStandsComponent } from './exhibitor-stands.component';

@Component({
    selector: 'manage-exhibitor',
    templateUrl: './manage-exhibitor.html',
    styleUrls: ['../manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, EntityTypesComponent, ToggleTabComponent, TipTextComponent, CommonModule, BinaryShareToggle, ImageUploaderComponent, InputEditorComponent, ManageSocialLinksComponent, ManageCallToActionComponent, ManageContactDetailsComponent, CustomQuestionsAppComponent, ManageContactComponent, ChatBoxComponent, EntityTasksComponent, TitleIconComponent, InformableComponent, AddLinkToBriefComponent, EditAssociatedAssetsManager, GreyWrapperComponent, BigAndGreyComponent, IdsToItemsPipe, ManageTermsComponent, AssetsComponent, AppBriefComponent, ExhibitorStandsComponent ],
})
export class ManageExhibitorDialogComponent extends Wrapper<ManageExhibitorDialogComponent> implements OnInit {
  exhibitor: Exhibitor
  
  labels: Label[] = []
  labelMap: { [id:string]: Label }
  contact: WFWorker
  imageUploaderDisplayTypes = imageUploaderDisplayTypes

  // exhibitorShareable: PublicEditProfileInfo
  exhibitorShareBaseUrl = environment.joi.shareBase + 'exhibitor/';
  exhibitorShareable: PublicEditProfileInfo;
  exhibitorBriefs: Dictionary<BriefInfo> = {}
  exhibitorDisplayTypes = exhibitorDisplayTypes
  generatingEditCode = false;
  event: JoiEvent
  standTypes: { [id:string]: Ranking } = {}
  programs: { [pId:string]: Program } = {}
  tabs = exhibitorTabs
  tabGroups: TabGroup[] = [{ tabs: [
    { id: exhibitorTabs.info, name: 'Exhibitor profile' },
    { id: exhibitorTabs.details, name: 'Exhibitor stands' },
    { id: exhibitorTabs.assets, name: 'Associated Assets' },
    { id: exhibitorTabs.schedule, name: 'Schedule' },
    { id: exhibitorTabs.quickNotes, name: 'Quick Notes', icon: 'sticky18' },
    { id: exhibitorTabs.contact, name: 'Workforce contact' },
    { id: exhibitorTabs.tasks, name: 'Tasks' },
  ]},{
    groupName: 'EXHIBITOR BRIEF',
    tabs: [
      
    { id: exhibitorTabs.briefInfo, name: 'Information for exhibitor' },
      { id: exhibitorTabs.configBrief, name: 'Manage actions' },
      { id: exhibitorTabs.preview, name: 'Share brief' },
    ]
  }]
  selectedTab
  clipLabel: ClipLabel
  readOnly: boolean
  eAsset: Dictionary<StandItemInfo>
  eRequest: Dictionary<StandItemInfo>
  standIds: string[] = []
  stands: Dictionary<ExhibitorStand>
  briefActions: BriefActions // for use in manage actions, apparently was not passed into brief view from here
  associatedAssetIds: string[] = []

  constructor(public changeDetectorRef: ChangeDetectorRef, public dialogRef: MatDialogRef<ManageExhibitorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageExhibitorData) {
    super()
    this.selectProp(associatedAssetsReselector, data.exhibitorId, 'associatedAssetIds')
    this.selectCallback(clipboardEditingPrivilegesReselector, null, canClip => {
      if (canClip && !this.clipLabel) this.clipLabel = '+ ADD TO CLIPBOARD'
    })
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('programs', 'entities'), 'programs')
    this.subProp(this.store.select('exhibitors', 'standTypes'), 'standTypes')
    this.subProp(this.store.select('shareables', 'exhibitor', data.exhibitorId), 'exhibitorShareable')
    this.take1(this.store.select('informables', 'exhibitor', this.data.exhibitorId)).then((informable)=>{
      if (!informable) this.informablesService.checkIfEntityDefaultsAreNeeded('exhibitor',this.eventService.eventId, this.data.exhibitorId)
    })
    this.subProp(this.store.select('shareables','exhibitorBrief'), 'exhibitorBriefs')
    this.subProp(this.store.select('shareables','eAsset'), 'eAsset')
    this.subProp(this.store.select('shareables','eRequest'), 'eRequest')
    this.subProp(this.store.select('exhibitorStands', 'entities'), 'stands')
    
    this.selectProp(exhibitorBriefActionsReselector, this.data.exhibitorId, 'briefActions')
    this.selectProp(exhibitorStandIdsByExhibitorIdReselector, this.data.exhibitorId, 'standIds')
  }
  

  ngOnInit() {
    this.subCallback(this.store.select('events', 'labelMaps', 'exhibitor_labels'), labels => {
      this.labels = Object.values(labels)
      this.labelMap = labels
    })
    this.subProp(this.store.select('exhibitors', 'entities', this.data.exhibitorId), 'exhibitor')
    this.subProp(this.store.select(manageSessionReadonlyReselector), 'readOnly')
  }

  public labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsToggled) {
      this.exhibitor.labels = labels
      this.exhibitorService.updateExhibitor(this.exhibitor)
    }
    if (labelsChanged ) {
      this.eventService.updateEvent(this.eventService.eventId, { exhibitor_labels: labelTemplate })
    }
  }

  async clip() {
    switch(this.clipLabel) {
      case '+ ADD TO CLIPBOARD':
        this.clipLabel = 'SAVING...'
        await this.exhibitorService.templateExhibitors([this.exhibitor])
        this.clipLabel = 'ADDED'
        break
      default:
        break // nothing to do
    }
  }

  setAssetStatus(status: ItemStatus, pa: AssetBriefAction) {
    this.assetService.changeAssetStatus(pa.assetId, status)
  }

  saveStars(stars: number) {
    this.exhibitor = { ...this.exhibitor, stars }
    this.saveExhibitor()
  }

  setStandItemStatus(standId: string, status: ItemStatus, type: StandItemType & keyof this) {
    const shareable = this[type][`${standId}_${ this.exhibitor.id }`]

    if (!shareable) {
      this.shareService.addNewSessionStandShareable(standId, this.exhibitor.id, type)
      return;
    }
    
    const { id, key } = shareable
    const info: StandItemInfo = { id, key, exhibitorId: this.exhibitor.id || null, standId, status }

    console.log({ standId, shareable, info })

    this.shareService.upsertShareInfo({ info }, id)
  }

  shareUrl(shareOn: boolean) {
    const brief = this.exhibitorBriefs[this.exhibitor.id]
    if (!brief) {
      this.shareBriefsService.addNewBrief('exhibitor', this.exhibitor.id)
      return
    }
    this.shareBriefsService.changeBriefShareStatus(brief, shareOn ? 'On' : 'Off')
  }
/* 
  saveFiles(files: JoiFile[]) {
    this.exhibitor.files = files
    this.saveExhibitor()
  } */

  changeTab(tab) {
    this.selectedTab = tab
  }

  saveSocialLinks(links: SocialLink[]) {
    this.exhibitor.social = links
    this.saveExhibitor()
  }

  changeLogo(result) {
    this.exhibitor.logoUrl = result ? result.thumbUrl : null
    this.exhibitor.fullLogoUrl = result ? result.photoUrl : null
    this.saveExhibitor()
  }

  exit() {
    this.dialogRef.close()
  }

  toggleExhibitorConfirmed() {
    this.exhibitor.confirmed = !this.exhibitor.confirmed
    this.saveExhibitor()
  }

  toggleHideInPublish() {
    this.exhibitor.hideInPublish = !this.exhibitor.hideInPublish;
    this.saveExhibitor();
  }

  toggleDetailsConfirmed() {
    this.exhibitor.detailsConfirmed = !this.exhibitor.detailsConfirmed
    this.saveExhibitor()
  }

  updateExhibitorName(name: string) {
    this.exhibitor.name = name
    this.saveExhibitor()
  }

  toggleExhibitorProfile() {
    if (!this.exhibitorShareable) {
      this.createExhibitorProfileShareable()
    } else if (this.exhibitorShareable.status !== publicEditProfileStatusTypes.Off) {
      this.changeExhibitorProfileStatus(publicEditProfileStatusTypes.Off)
    } else {
      this.changeExhibitorProfileStatus(publicEditProfileStatusTypes.Active)
    }
  }

  async createExhibitorProfileShareable () {
    this.generatingEditCode = true;
    await this.shareService.createEditProfileCode(this.exhibitor.id, this.event.eventId, 'exhibitor')
    this.generatingEditCode = false
  }

  changeExhibitorProfileStatus(status){
    const profile: PublicEditProfileInfo = { code: this.exhibitorShareable.code, status, exhibitorId: this.exhibitor.id }
    // console.log({ profile })
    this.shareService.updateProfileInfo(profile)
  }

  updateShowEditProfileLinkInBrief(){
    this.exhibitor = { ...this.exhibitor, showEditProfileLinkInBrief: !this.exhibitor.showEditProfileLinkInBrief }
    this.saveExhibitor()
    if (!this.exhibitorShareable) this.createExhibitorProfileShareable()
    else if (this.exhibitor.showEditProfileLinkInBrief && this.exhibitorShareable?.status !== 'Active') this.changeExhibitorProfileStatus('Active')
  }
  
  async changeWorkforceContact(personEmail: string) {
    const workforceContactEmail = personEmail === this.exhibitor.workforceContactEmail ? null : personEmail
    this.exhibitor = { ...this.exhibitor, workforceContactEmail }
    this.saveExhibitor()
  }

  updateCustomQuestion(data: UpdateQuestionOutput) {
    const { id, answer } = data
    this.exhibitor.customQuestions[id] = answer
    this.saveExhibitor()
  }

  saveExhibitor() {
    this.exhibitorService.updateExhibitor(this.exhibitor)
  }

  async deleteExhibitor(event) {
    this.dialogRef.close()
    this.exhibitorService.deleteExhibitor(this.exhibitor)
  }

  async duplicateExhibitor() {
    this.dialogRef.close()
    this.exhibitorService.duplicateExhibitor(this.exhibitor)
  }

  saveQuickNotes(quickNotes: JoiComment[]) {
    // console.log({ quickNotes })
    this.exhibitor.quickNotes = quickNotes
    this.saveExhibitor()
  }

}

export interface ManageExhibitorData {
  exhibitorId: string
  nested?: boolean
}
